<!-- vue\public\index.html に App.vue が差し込まれる -->
<template>
    <div class="contents-height flex">
        <SidebarArea class="sidemenu-width" :selectedCmd="selectedCmd" @clicked-jumpList="scrollToTarget"></SidebarArea>
        <!-- フォーム -->
        <div ref="formArea" class="form-contents contents-width">
            <!-- OS -->
            <fieldset id="os">
                <legend>OS</legend>
                <div>
                    コマンドを使用するOSを選択してください。
                </div>
                <div class="form-area">
                    <label for="WindowsOs">
                        <input type="radio" class="input-radio" id="WindowsOs" v-model="selectedOS" name="osRadio"
                            value="win" checked @change="updateCmd">
                        Windows ( cd %USERPROFILE%\AppData\Local\Programs\T-DASH )
                    </label><br>
                    <label for="macOS">
                        <input type="radio" class="input-radio" id="macOS" v-model="selectedOS" name="osRadio"
                            value="mac" @change="updateCmd" disabled>
                        <del>Mac ( cd /Apprication ) </del>※対象外
                    </label>
                </div>
            </fieldset>

            <!-- コマンド -->
            <fieldset id="cmd">
                <legend>コマンド</legend>
                <div>
                    実行するコマンドを選択してください。
                </div>
                <div class="form-area">
                    <!-- webコマンド -->
                    <input type="radio" class="input-radio" id="commandSetup" v-model="selectedCmd" name="commandRadio"
                        value="setup" @change="updateCmd">
                    <label for="commandSetup">setupコマンド: Webアプリ用のコマンドライン実行環境を構築する</label><br>
                    <input type="radio" class="input-radio" id="commandShowTestrun" v-model="selectedCmd"
                        name="commandRadio" @change="updateCmd" value="show_testrun">
                    <label for="commandShowTestrun">show_testrunコマンド: Webアプリ用のテストラン一覧を確認する</label><br>
                    <input type="radio" class="input-radio" id="commandTestrun" v-model="selectedCmd"
                        name="commandRadio" value="testrun" @change="updateCmd" checked>
                    <label for="commandTestrun">testrunコマンド: Webアプリのテストランを実行する</label>
                    <!-- winコマンド -->
                    <div v-if="isSelectedWin">
                        <input type="radio" class="input-radio" id="commandShowTestrunWin" v-model="selectedCmd"
                            name="commandRadio" @change="updateCmd" value="show_testrun_win">
                        <label for="commandShowTestrunWin">show_testrun_winコマンド: Windowsアプリ用のテストラン一覧を確認する</label><br>
                        <input type="radio" class="input-radio" id="commandTestrunWin" v-model="selectedCmd"
                            name="commandRadio" value="testrun_win" @change="updateCmd">
                        <label for="commandTestrunWin">testrun_winコマンド: Windwosアプリのテストランを実行する</label><br>
                        <!-- モバイルコマンド -->
                        <input type="radio" class="input-radio" id="commandShowTestrunMobile" v-model="selectedCmd"
                            name="commandRadio" @change="updateCmd" value="show_testrun_mobile">
                        <label for="commandShowTestrunMobile">show_testrun_mobileコマンド: モバイルアプリ用のテストラン一覧を確認する</label><br>
                        <input type="radio" class="input-radio" id="commandTestrunMobile" v-model="selectedCmd"
                            name="commandRadio" value="testrun_mobile" @change="updateCmd">
                        <label for="commandTestrunMobile">testrun_mobileコマンド: モバイルアプリのテストランを実行する</label><br>
                    </div>
                </div>
            </fieldset>

            <!-- コマンドごとのフォーム -->
            <SetupCmd v-if="selectedCmd === 'setup'" @update-cmd="updateOpt"></SetupCmd>
            <ShowTestrunCmd v-if="selectedCmd === 'show_testrun'" @update-cmd="updateOpt"></ShowTestrunCmd>
            <TestrunCmd v-if="selectedCmd === 'testrun'" @update-cmd="updateOpt"></TestrunCmd>
            <ShowTestrunWinCmd v-if="selectedCmd === 'show_testrun_win'" @update-cmd="updateOpt">
            </ShowTestrunWinCmd>
            <TestrunWinCmd v-if="selectedCmd === 'testrun_win'" @update-cmd="updateOpt">
            </TestrunWinCmd>
            <!-- モバイル -->
            <ShowTestrunMobileCmd v-if="selectedCmd === 'show_testrun_mobile'" @update-cmd="updateOpt">
            </ShowTestrunMobileCmd>
            <TestrunMobileCmd v-if="selectedCmd === 'testrun_mobile'" @update-cmd="updateOpt">
            </TestrunMobileCmd>
        </div>
    </div>
    <div class="footer-height footer-color cmd-copy-continer">
        <v-btn class="cmd-copy-btn" @click="copyToClipboard(createdCmd)"
            @contextmenu.prevent="isShowFullCmdDialog = true">
            <div class="cmd-copy-btn-text">
                {{ createdCmdToDisplay }}
            </div>
            <v-tooltip activator="parent" location="top" text="左クリックでコピー / 右クリックで全文表示"></v-tooltip>
        </v-btn>
    </div>

    <!-- ナビ -->
    <v-snackbar v-model="showCopyToast" color="success" :min-width=0 text="コピーしました" :timeout=1500
        style="bottom: 110px"></v-snackbar>
    <HelpDialog :isShow="isShowFullCmdDialog" @close="isShowFullCmdDialog = false" title="コマンド全文">
        <template v-slot:contents>
            <div class="flex" style="align-items: center;place-content: center;">
                <v-btn @click="copyToClipboard(createdCmd, false)" style="background-color: blue;color: aliceblue;">
                    cdコマンド無しでコピー
                </v-btn>
                <div style="margin-left: 20px;">
                    ※cdコマンドが不要な場合に使用してください。<br>
                    例1: %USERPROFILE%が異なる設定の場合(Jenkins環境など)<br>
                    例2: T-DASHの実行ファイルが標準のフォルダ(%USERPROFILE%/AppData/Local/Programs/T-DASH)に存在しない場合
                </div>
            </div>

            <div class="full-cmd-container">
                {{ createdCmdToDisplay }}
            </div>
        </template>
    </HelpDialog>
</template>

<script>
// 標準
import { computed, onMounted, onUpdated, ref } from 'vue';

// 独自
import SidebarArea from '@/components/SidebarArea.vue'
import SetupCmd from '@/views/commands/SetupCmd.vue'
import ShowTestrunCmd from '@/views/commands/ShowTestrunCmd.vue'
import TestrunCmd from '@/views/commands/TestrunCmd.vue'
import ShowTestrunWinCmd from '@/views/commandsWin/ShowTestrunWinCmd.vue'
import TestrunWinCmd from '@/views/commandsWin/TestrunWinCmd.vue'
import ShowTestrunMobileCmd from '@/views/commandsMobile/ShowTestrunMobileCmd.vue'
import TestrunMobileCmd from '@/views/commandsMobile/TestrunMobileCmd.vue'
import cacheUtils from '@/js/cacheUtils';


export default {
    name: 'ContentsArea',
    components: {
        SidebarArea,
        SetupCmd,
        ShowTestrunCmd,
        TestrunCmd,
        ShowTestrunWinCmd,
        TestrunWinCmd,
        ShowTestrunMobileCmd,
        TestrunMobileCmd,
    },
    setup() {
        // #############
        // 選択状況(OS) #
        // #############
        const isSelectedWin = computed(() => {
            if (selectedOS.value === "win") {
                return true
            }
            // winコマンド選択中にmacOSを選択したら、選択コマンドをwebコマンドに戻す
            // ※computedの仕様のため、別ref変数を更新する際、関数を分ける
            changeCmdByOs(selectedCmd.value)
            return false
        })
        const changeCmdByOs = (cmd) => {
            if (["show_testrun_win", "testrun_win"].includes(cmd)) {
                selectedCmd.value = "testrun"
            }
        }

        // ###############
        // フォームデータ #
        // ###############
        const selectedOS = ref("")
        const selectedCmd = ref("")
        const selectedOpt = ref([{}])

        // #############
        // コマンド更新 #
        // #############
        const createdCmd = ref(`tdash.exe ${selectedCmd.value}`)
        const createdOpt = ref("")
        const updateCmd = async () => {
            let exeName = "tdash.exe"
            if (!isSelectedWin.value) {
                exeName = "t-dash.app/Contents/MacOS/t-dash"
            }

            // cacheに保存
            await cacheUtils.saveData("os", selectedOS.value)
            await cacheUtils.saveData("cmd", selectedCmd.value)

            createdCmd.value = `${exeName} ${selectedCmd.value} ${createdOpt.value}`
        }
        const updateOpt = (optsStr) => {
            createdOpt.value = optsStr
            updateCmd()
        }
        const createdCmdToDisplay = computed(() => {
            // コマンドを見やすいように、１行につきオプション&引数の組み合わせになるように改行で区切る
            return createdCmd.value.replace(/(--\w+(?:\s+\w+)?)/g, '\n$1');

        })

        // ######################
        // クリップボードにコピー #
        // ######################
        const copyToClipboard = (textToCopy, isNeedCd = true) => {
            if (!navigator.clipboard) {
                alert("このブラウザは対応していません");
                return;
            }

            let cdCmd = "cd %USERPROFILE%\\AppData\\Local\\Programs\\T-DASH "
            if (!isSelectedWin.value) {
                cdCmd = "cd /Apprication"
            }

            if (isNeedCd) {
                // クリップボードにコピーする
                navigator.clipboard.writeText(`${cdCmd}\n${textToCopy}\n`)
            } else {
                navigator.clipboard.writeText(`${textToCopy}\n`)
            }
            // トースト表示
            showCopyToast.value = true
        }

        // #########
        // トースト #
        // #########
        const showCopyToast = ref(false)

        // ###########
        // スクロール #
        // ###########
        // * サイドバーからのスクロール
        const formArea = ref()
        const scrollToTarget = (target, reqTitle, reqKey) => {
            if (!formArea.value) {
                return
            }

            // ヘッダー分(vhの5%)スクロール量を調整
            const fiveVh = window.innerHeight / 20

            // スクロール
            const element = document.getElementById(target);
            if (element) {
                formArea.value.scrollTop = element.offsetTop - fiveVh
                return
            }

            // ターゲットが見つからなかったら、入力の前提が漏れているので、そちらにスクロール
            if (reqTitle) {
                alert(`1つ以上の必要な項目が入力されていません。\n\n【必要な項目】\n${reqTitle}`)
                const reqElement = document.getElementById(reqKey);
                if (reqElement) {
                    // ヘッダー分(vhの5%)スクロール量を調整
                    formArea.value.scrollTop = reqElement.offsetTop - fiveVh
                    return
                }
            }
        }

        // * リロード前の座標を保持
        window.addEventListener('beforeunload', async () => {
            await cacheUtils.saveData("scrollTopBeforeReload", formArea.value.scrollTop)
        });

        // ################
        // コマンド全文表示 #
        // ################
        const isShowFullCmdDialog = ref(false)

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            selectedOS.value = await cacheUtils.getData("os", "win")
            selectedCmd.value = await cacheUtils.getData("cmd", "testrun")

            await updateCmd()
        })

        onUpdated(async () => {
            const temp = await cacheUtils.getData("scrollTopBeforeReload", 0)
            console.log(temp)
            // formArea.value.scrollTop = temp
        })

        return {
            // 選択状況
            isSelectedWin,
            // フォーム
            selectedOS,
            selectedCmd,
            selectedOpt,
            // コマンド更新
            createdCmd,
            createdCmdToDisplay,
            updateCmd,
            updateOpt,
            // クリップボードにコピー
            copyToClipboard,
            // トースト
            showCopyToast,
            // スクロール
            formArea,
            scrollToTarget,
            // コマンド全文表示
            isShowFullCmdDialog,
        }
    }
}
</script>


<style scoped>
.contents-height {
    height: 80vh;
}

.contents-width {
    width: 80vw;
}

.sidemenu-width {
    width: 20vw;
}

.footer-height {
    height: 15vh;
}

.flex {
    display: flex;
}

.footer-color {
    background-color: #0D1F38;
}

.form-contents {
    color: black;
    background-color: #F4F7FC;
    gap: 20px;
    display: grid;
    overflow-y: scroll;
    scrollbar-width: thin;
    grid-auto-rows: max-content;
}

/* コマンドコピー */
.cmd-copy-continer {
    text-align: center;
    align-content: center;
}

.cmd-copy-btn {
    width: 97vw;
    height: 90% !important;
    text-transform: unset !important;
}

.cmd-copy-btn-text {
    white-space: break-spaces !important;
    word-wrap: break-word !important;
    width: 94vw !important;
    height: 12vh !important;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;
    /* align-content: center; */
    text-align: left;
}
</style>

<style>
.full-cmd-container {
    white-space: break-spaces;
    word-wrap: break-word;
    text-align: left;
    margin: 15px;
    padding: 15px;
    border-radius: 5px !important;
    border: 1px solid #dee2e6 !important;
    background: aliceblue;
}
</style>